import React, { useEffect, useState, useContext } from 'react';
import { useDropzone } from 'react-dropzone';
import { ReactComponent as PlusIcon } from '../Assets/svg/PlusIcon.svg';
import { ReactComponent as CameraIcon } from '../Assets/svg/CameraIcon.svg';
import http from '../api/axiosInstance'

import { Box } from '@mui/system';
function UsersDropZone(props) {
    const [files, setFiles] = useState([]);
    const [loading, setLoading] = useState(false);

    const { getRootProps, getInputProps } = useDropzone({
        accept: {
            'image/*': []
        },
        onDrop: async acceptedFiles => {
            setLoading(true)
            setFiles(acceptedFiles.map(file => Object.assign(file, {
                preview: URL.createObjectURL(file)
            })));
            props.setUserImg(acceptedFiles.map(file => Object.assign(file, {
                preview: URL.createObjectURL(file)
            })));
            console.log("file", acceptedFiles[0])
            console.log("userImg", props.userImg)

            setLoading(false)
        }
    });

    const thumbs = files.map(file => ( 
        <div key={file.name}>
            <img
                src={file.preview}
                // Revoke data uri after image is loaded
                onLoad={() => { URL.revokeObjectURL(file.preview) }}
            />
        </div>
    ));

    console.log("files",props.uploadedImg)

    useEffect(() => {
        // Make sure to revoke the data uris to avoid memory leaks, will run on unmount
        return () => files.forEach(file => URL.revokeObjectURL(file.preview));
    }, []);

    return (

        <div {...getRootProps({ className: 'dropzone' })}>
            {
                loading ?
                    <Box sx={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: '2', position: 'absolute', bgcolor: '#ffffffa3' }}>
                        <img src='/assets/img/ladng2.gif' width='30' />
                    </Box>
                    :
                    null
            }
            <input {...getInputProps()} />
            <PlusIcon width='10' height="10" />
            <CameraIcon />
            <div className='dropzone-img'>
                {files.length ? thumbs :
                    props.uploadedImg && <div>
                        <img
                            src={props.uploadedImg}                             
                        />
                    </div>}
            </div>

        </div>

    );
}

export default UsersDropZone;